import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { translationVersionAtom } from '@/state/atom/translationAtom';

// Errors set manually via setError (e.g. backend errors) are not produced by the schema;
// re-validating those fields would wipe them, so they are skipped.
const NON_SCHEMA_ERROR_TYPES = ['server', 'manual'];

/**
 * Re-validates the fields that currently show a schema error whenever the translation
 * dictionary is loaded or extended.
 *
 * Yup error messages are only built at validation time, so an error already on
 * screen keeps its old (untranslated) text after the dictionary loads. Triggering
 * validation again rebuilds the message with the new translation.
 *
 * @param {Object} errors - react-hook-form `errors` object
 * @param {Function} trigger - react-hook-form `trigger` function
 */
export default function useRevalidateOnTranslation(errors, trigger) {
    const translationVersion = useRecoilValue(translationVersionAtom);

    useEffect(() => {
        const errorFields = Object.keys(errors || {}).filter(
            field => !NON_SCHEMA_ERROR_TYPES.includes(errors[field]?.type)
        );
        if (errorFields.length > 0) {
            trigger(errorFields);
        }
        // Only re-run when the dictionary changes, not on every error change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translationVersion]);
}
